import { Box, Skeleton, Typography } from '@mui/material';
import React from 'react';
import { useIsDesktop } from '@/ui-kit/hooks/useIsDesktop';
import { useStyles } from '../hooks/useStyles';

export const SliderSkeleton: React.FC = () => {
    const isDesktop = useIsDesktop();
    const classes = useStyles();
    return (
        <Box pt={0.5}>
            <Skeleton
                variant='rectangular'
                width='100%'
                height={isDesktop ? 333 : 200}
                sx={{
                    borderRadius: 1,
                }}
            />
            <Box
                sx={{
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    mt: 2,
                }}
            >
                <Skeleton variant='text' width='80%'>
                    <Typography variant='h3' className={classes.subTitle}>
                        Slider title
                    </Typography>
                </Skeleton>
                <Skeleton variant='text' width='80%'>
                    <Typography variant='body2' className={classes.paraText}>
                        Slider text
                    </Typography>
                </Skeleton>
            </Box>

            <Box
                sx={{
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    mt: 1,
                }}
            >
                <Skeleton
                    variant='circular'
                    width={10}
                    height={10}
                    sx={{
                        mr: 2,
                    }}
                />
                <Skeleton
                    variant='circular'
                    width={10}
                    height={10}
                    sx={{
                        mr: 2,
                    }}
                />
                <Skeleton
                    variant='circular'
                    width={10}
                    height={10}
                    sx={{
                        mr: 2,
                    }}
                />
                <Skeleton
                    variant='circular'
                    width={10}
                    height={10}
                    sx={{
                        mr: 2,
                    }}
                />
            </Box>
        </Box>
    );
};
